import React from "react";

const ErrorBox = ({ msg }) => {
  return <p className="text-sm mb-1 text-red-500 max-w-xs ml-4">{msg}</p>;
};

export default ErrorBox;
